module.exports = __webpack_public_path__ + "static/media/chrome-instructions.78d343c9.png";